module.exports = __webpack_public_path__ + "img/v2.1.8275d2a4.png";